'use client';

import { useAuth } from '@ahm/react-auth';
import { useTranslations } from 'next-intl';
import BookingHeading from './booking-heading';
import BookingServiceHeading from '@/features/booking/components/services/booking-service-heading';
import { useGetRemoteConfig } from '@/features/home/api/use-get-remote-config';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type BookingServiceBlockHeaderProps = {
  title?: string;
  showBookingServiceHeading?: boolean;
};

export default function BookingServiceBlockHeader({
  title,
  showBookingServiceHeading = true,
}: BookingServiceBlockHeaderProps) {
  const isMobile = useIsMobile();
  const tBooking = useTranslations('booking');

  const { session } = useAuth();
  const user = session?.user;
  const { data } = useGetRemoteConfig({
    enabled: Boolean(user),
  });
  console.log('data', data);

  return (
    <BookingHeading title={title ?? tBooking('newOrder')}>
      {!isMobile && showBookingServiceHeading ? (
        <BookingServiceHeading />
      ) : null}
    </BookingHeading>
  );
}
